module.exports = __webpack_public_path__ + "img/l1.2fb520d4.jpg";